// extracted by mini-css-extract-plugin
export default {"buttons":"PopupDeleteQuestionOption_buttons__-G1YA","button":"PopupDeleteQuestionOption_button__RwW5v"};